<template>
	<v-container>
	  <v-row justify="center" class="mb-10">
	  	<!-- Información básica del grupo -->
	  	<v-col cols="12" class="pb-1">
	  		<v-card class="elevation-0 transparent">
	  			<v-card-text>
						<div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
              Lecciones
            </div>
	  			</v-card-text>
	  		</v-card>
			<v-card class="shadowCard recursos mb-2" @click="$router.push({name: 'ExamenCalidad'})" style="max-width: 200px; margin: 0 auto;">
				<v-card-text v-if="id_evaluacion != 0">
					<v-row justify="center">
						<v-icon dark class="me-2">mdi-note-text</v-icon>
						<h5 class="mb-0 font-weight-bolder white--text text-h6" > Examen Calidad </h5>
					</v-row>
				</v-card-text>
			</v-card>
	  	</v-col>


	  	<v-col cols="12" sm="7" md="6" lg="5">
		    <v-expansion-panels>
		      <v-expansion-panel v-for="(leccion, i) in getRecursosGrupoUsuario" :key="i">
		        <v-expansion-panel-header disable-icon-rotate>
		        	<!-- Titulo -->
		          <v-list-item class="px-2">
				        <v-list-item-content>
				          <v-list-item-title>
				            {{ leccion.leccion }}
				          </v-list-item-title>

				          <v-list-item-subtitle v-if="leccion.abrir == 1 && tieneCalificacion(leccion.calificacion)">Ejercicio realizado</v-list-item-subtitle>
				          <v-list-item-subtitle v-if="leccion.abrir == 1 && !tieneCalificacion(leccion.calificacion)">Ejercicio faltante</v-list-item-subtitle>
				          <v-list-item-subtitle v-if="leccion.abrir == 2">Disponible a partir del: {{ leccion.fecha }}</v-list-item-subtitle>
				        </v-list-item-content>
				      </v-list-item>

				      <!-- Estatus -->
		          <template v-slot:actions>
			          <v-avatar
			            size="40"
			            color="transparent"
			            rounded
			            :class="`elevation-1 avatares ${ getSymbolLeccion( leccion.abrir, leccion.calificacion, 1) }`"
			          >
			            <v-icon color="white" v-text="getSymbolLeccion( leccion.abrir, leccion.calificacion, 2)">mdi-check</v-icon>
			          </v-avatar>
		          </template>

		        </v-expansion-panel-header>


		        <!-- Panel informativo -->
		        <v-expansion-panel-content v-if="leccion.abrir == 1">
		        	<v-divider></v-divider>
		        	<v-card-actions class="pt-4">
		        		<v-row>

		        			<!-- Ejercicio -->
		        			<v-col cols="3" 
		        				v-if="leccion.ejercicios > 0"
		        				class="px-0"
		        				align="center"
		        			>
				        		<v-card 
			        				@click="abrirRecurso(leccion.recursos, 1, 1 )"
			        				width="42" 
			        				height="42" 
			        				class="elevation-0 transparent"
										>
											<v-img src="@/assets/iconos/documento.svg"></v-img>
										</v-card>
										<span class="text-caption">Ejercicio</span>
		        			</v-col>

		        			<!-- Examenes -->
		        			<v-col cols="3" 
		        				v-if="leccion.examenes > 0 && leccion.examen && leccion.asistencia != 2"
		        				class="px-0" 
		        				align="center"
		        			>
				        		<v-card 
			        				@click="abrirRecurso(leccion.recursos, 2, 2 )"
			        				width="42" 
			        				height="42" 
			        				class="elevation-0 transparent"
										>
											<v-img src="@/assets/iconos/documento.svg"></v-img>
										</v-card>
										<span class="text-caption">Examen</span>
		        			</v-col>

		        			<!-- Examene de recuperación -->
		        			<v-col cols="3" 
		        				v-if="leccion.examenes > 0 && leccion.exaRec && leccion.asistencia == 2"
		        				class="px-0" 
		        				align="center"
		        			>
				        		<v-card 
			        				@click="abrirRecurso(leccion.recursos, 2, 3 )"
			        				width="42" 
			        				height="42" 
			        				class="elevation-0 transparent"
										>
											<v-img src="@/assets/iconos/documento.svg"></v-img>
										</v-card>
										<span class="text-caption">Examen rec.</span>
		        			</v-col>

		        			<!-- PDFS -->
		        			<v-col cols="3" 
		        				v-if="leccion.pdfs > 0"
		        				class="px-0"
		        				align="center"
		        			>
		        				<v-card 
			        				@click="abrirRecurso(leccion.recursos, 3, 4 )"
			        				width="42" height="42" class="elevation-0 transparent">
											<v-img src="@/assets/iconos/pdf.svg" ></v-img>
										</v-card>
										<span class="text-caption">PDF</span>
		        			</v-col>

		        			<!-- Videos -->
		        			<v-col cols="3" 
		        				v-if="leccion.videos > 0"
		        				class="px-0"
		        				align="center"
		        			>
		        				<v-card 
			        				@click="abrirRecurso(leccion.recursos, 4, 5 )"
			        				width="42" height="42" class="elevation-0 transparent">
											<v-img src="@/assets/iconos/youtube.svg" ></v-img>
										</v-card>
										<span class="text-caption">Video</span>
		        			</v-col>

		        			<!-- Asistencia -->
		        			<v-col cols="3"
		        				class="px-0"
		        				align="center"
		        			>
		        				<v-card 
			        				width="42" height="42" class="elevation-0 transparent">
											<v-icon 
												:color="getIconAsistencia( leccion.asistencia, 1 )" 
												large
												v-text="getIconAsistencia( leccion.asistencia, 2)"
											></v-icon>
										</v-card>
										<span class="text-caption">{{ leccion.valor_text }}</span>
		        			</v-col>
		        		</v-row>
		        	</v-card-actions>
		        </v-expansion-panel-content>

		      </v-expansion-panel>
		    </v-expansion-panels>
	  	</v-col>
	  </v-row>

	  <v-speed-dial
      top
      left
      fixed
    >
      <template v-slot:activator>
        <v-btn
          color="white"
          fab
          :to="{name: 'DetalleGrupo'}"
        >
          <v-icon color="primary">
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

	  <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader    v-if="cargar"          :loader="loader"/>

	</v-container>
</template>
<script>
	// importar librerías
	import { mapGetters, mapActions } from 'vuex'

	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

	export default {
	  name: "dashboard-default",
	  data: () => ({
	  	show: false,

    	respuestaAlerta: false,
    	diaNumExamenFinal:0,

      loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},

	  info_evaluacion:[],
	  id_evaluacion:[],

	  }),

	  components: {
	    Alerta,
	    Loader
	  },

	  created(){
	  	this.getEvaluacion()
	  },

	  computed:{
	  	...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getRecurso' ]),

	  	diaNumExamenMedio( ){
	  		return ( this.getRecursosGrupoUsuario.length / 2)
	  	}
	  },

	  methods:{
	  	...mapActions( 'login', [ 'abrirVentanaRecurso'] ),

	  	getIconAsistencia( value, type ){
	  		switch ( value ){
	  			case 1 :
	  				return  type == 1 ? 'green': 'mdi-account-check'
	  			break;

	  			case 2 :
	  				return  type == 1 ? 'red': 'mdi-account-remove'
	  			break;

	  			case 0 :
	  				return  type == 1 ? 'red': 'mdi-account-remove'
	  			break;

	  			case 3:
	  				return  type == 1 ? 'warning' : 'mdi-account-minus'
	  			break;

	  			case 3:
	  				return  type == 1 ? 'orange' : 'mdi-account-convert'
	  			break;
	  		}
	  	},

	  	tieneCalificacion( calificacion ){
	  		return calificacion !== null && calificacion !== undefined && calificacion !== ''
	  	},

	  	getSymbolLeccion( abrir, calificacion, type ){
	  		if( abrir == 1 ){
	  			if( this.tieneCalificacion( calificacion ) ){
	  				return type == 1 ? 'shadowCardCheck' : 'mdi-check'
	  			}
	  			return type == 1 ? 'shadowCardAlerta' : 'mdi-alert'
	  		}
	  		return type == 1 ? 'shadowCardCalendar' : 'mdi-clock'
	  	},

	  	getTypeRecurso( cantidad, type ){
	  		switch ( value ){
	  			case 1 :
	  				return  type == 1 ? 'green': 'Ejercicios'
	  			break;

	  			case 2 :
	  				return  type == 1 ? 'red': 'Exámenes'
	  			break;

	  			case 3 :
	  				return  type == 1 ? 'red': 'Exámenes'
	  			break;

	  			case 4:
	  				return  type == 1 ? 'warning' : 'PDF'
	  			break;

	  			case 3:
	  				return  type == 1 ? 'orange' : 'Videos'
	  			break;
	  		}
	  	},

	  	abrirRecurso ( recursos, ventana, tipo ){
	  		const recursosPorAbrir = recursos.filter( el=> { return el.tipo == tipo })
	  		const payload = {
	  			recursosPorAbrir,
	  			ventana
	  		}

				console.log('Payload',payload)
				// console.log('leccion', this.getRecursosGrupoUsuario)
	  		// Abrir la ventana, mandar los recursos y mandar que ventana se abrirá
	  		this.abrirVentanaRecurso( payload )
	  	},

		getEvaluacion ( ){
  		this.cargar = true

	  	const payload = {id_grupo:   this.getGrupo.grupo.id}

	  	// Hacer la ptetición
	  	this.$http.post('get.evaluacion', payload).then(response => {
	  		this.info_evaluacion   = response.body
        this.id_evaluacion = this.info_evaluacion[0].id_evaluacion
	  		this.loading  = false
	  		this.cargar   = false
        this.initialize()
	  	}).catch( error =>{
	  		this.validarErrores ( error )
  		}).finally( () => { this.cargar = false })

	  	// this.preguntas.evaluacion = []
	  	},

	  	validarErrores ( value ){
	  		this.cargar = false
  			if( value.status == 400 || value.status == 500 ){
    			this.parametros.mensaje = value.body.message
  				this.parametros.color        = '#FF2C2C'
    			this.parametros.dialogError  = true 
    			this.respuestaAlerta = true 
    		}
	  	}
	  }
	};
</script>

<style scoped>
	.avatares{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.shadowCardCalendar{
		border-radius: 50px !important; 
		background: rgb(101,101,101);
		background: linear-gradient(90deg, rgba(101,101,101,1) 0%, rgba(210,208,206,1) 100%);
	}

	.shadowCardAlerta{
		border-radius: 50px !important; 
		background: rgb(255,106,0);
		background: linear-gradient(90deg, rgba(255,106,0,1) 0%, rgba(255,179,103,1) 100%);
	}

	.shadowCardCheck{
		border-radius: 50px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
	}

	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
	}
	
	.colorCurso{
		color: #006093;
	}

	.calificaciones{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.recursos{
		background: rgb(233,186,255);
		background: linear-gradient(90deg, rgba(233,186,255,1) 0%, rgba(186,52,251,1) 100%);
	}
</style>


